export enum Action {
  REDIRECT_OSC_MESSAGE = "redirect-osc-message",
  RTC_OFFER = "rtc-offer",
  NEW_ICE_CANDIDATE = "new-ice-candidate"
}
